import { Controller } from "@hotwired/stimulus"

// Pusht een conversie-event naar de GTM/GA dataLayer: bij het laden van het element
// (standaard) of bij een actie (on-connect uit, data-action="click->analytics-event#push").
export default class extends Controller {
  static values = { payload: Object, onConnect: { type: Boolean, default: true } }

  connect() {
    if (this.onConnectValue) this.push()
  }

  push() {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(this.payloadValue)
  }
}
